import { isEmpty } from "lodash";

export function propsToInitialState(
  data,
  chucVuList,
  phongBanList,
  coQuanQuanLyList,
  rolesByCapList,
  profile,
  coSoSanXuatList,
  coSoCheBienList,
  coSoPhanPhoiList
) {
  const dataInit = {
    userName: data?.userName || null,
    fullName: data?.fullName || null,
    password: null,
    email: data?.email || null,
    mobile: data?.mobile || null,
    chucVu: chucVuList?.find(x => x?.id === data?.chucVu?.id) || null,
    phongBan: phongBanList?.find(x => x?.id === data?.phongBan?.id) || null,
    coQuanQuanLy:
      coQuanQuanLyList?.find(x => x?.id === data?.coQuanQuanLy?.id) || null,
    roles: isEmpty(
      data?.roleId?.map(item => rolesByCapList?.find(x => x?.id === item))?.[0]
    )
      ? null
      : data?.roleId?.map(item => rolesByCapList?.find(x => x?.id === item)),
    address: data?.address || null,
    doanhNghiep: profile?.doanhNghiep || null,
    coSoSanXuat: coSoSanXuatList?.find(x => x?.id === data?.idCoSoSanXuat) || null,
    coSoCheBien: coSoCheBienList?.find(x => x?.id === data?.idCoSoCheBien) || null,
    coSoPhanPhoi: coSoPhanPhoiList?.find(x => x?.id === data?.idCoSoPhanPhoi) || null
  };
  return dataInit;
}

export function parseDataSaveUpdate(value) {
  const dataSave = { ...value };
  dataSave.phongBanId = value?.phongBan?.id || 0;
  dataSave.chucVuId = value?.chucVu?.id || 0;
  dataSave.coQuanQuanLyId = value?.coQuanQuanLy?.id || 0;
  dataSave.roleId = value?.roles?.map(item => item?.id);
  dataSave.idDoanhNghiep = value?.doanhNghiep?.id || 0;
  dataSave.idCoSoSanXuat = value?.coSoSanXuat?.id || 0;
  dataSave.idCoSoCheBien = value?.coSoCheBien?.id || 0;
  dataSave.idCoSoPhanPhoi = value?.coSoPhanPhoi?.id || 0;
  return dataSave;
}

export function parseDataSaveAdd(value) {
  const dataSave = { ...value };
  dataSave.phongBanId = value?.phongBan?.id || 0;
  dataSave.chucVuId = value?.chucVu?.id || 0;
  dataSave.coQuanQuanLyId = value?.coQuanQuanLy?.id || 0;
  dataSave.roleId = value?.roles?.map(item => item?.id);
  dataSave.idDoanhNghiep = value?.doanhNghiep?.id || 0;
  dataSave.idCoSoSanXuat = value?.coSoSanXuat?.id || 0;
  dataSave.idCoSoCheBien = value?.coSoCheBien?.id || 0;
  dataSave.idCoSoPhanPhoi = value?.coSoPhanPhoi?.id || 0;
  return dataSave;
}
